<template>
  <van-list
    class="participate-box"
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    :error.sync="error"
    error-text="请求失败，点击重新加载"
    @load="onLoad"
  >
    <div
      class="participate-item"
      v-for="item in myparticipatelist"
      :key="item.id"
    >
      <div class="participate-item-img">
        <img v-lazy="$global.imgUrl + item.cover" alt="" />
        <img
          class="icon-img"
          src="@/assets/mylogin/not-meeting.png"
          alt=""
          v-if="item.timeStatus === '未开始'"
        />
        <img
          class="icon-img"
          src="@/assets/mylogin/slices/finished.png"
          alt=""
          v-if="item.timeStatus === '已结束'"
        />
        <img
          class="icon-img"
          src="@/assets/mylogin/inMeeting.png"
          alt=""
          v-if="item.timeStatus === '会议中'"
        />
      </div>
      <div class="participate-item-content">
        <p class="title">{{ item.title }}</p>
        <div class="intro-box">
          <div class="intro-address">{{ item.province }}-{{ item.city }}</div>
          <div class="intro-time">{{ item.createTime.slice(0, 10) }}</div>
        </div>
        <div class="btn-box">
          <div
            class="btn-item"
            @click="toMeetingDetails(item.id, item.goodsId, item.open)"
          >
            进入会议
          </div>
          <div
            v-if="item.manuscripts && item.manuscripts.length"
            class="btn-item"
            @click="toEditDetails(item)"
          >
            会议稿件
          </div>
        </div>
      </div>
    </div>
  </van-list>
</template>

<script>
export default {
  name: "participated",
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      myparticipatelist: [],
      pageNo: 0,
      pageSize: 20,
    };
  },
  methods: {
    // 触底加载
    onLoad() {
      this.pageNo += 1;
      this.getList();
    },
    async getList() {
      const res = await this.$apis.myServe.getParticipateList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      if (res.resultCode == 200) {
        this.finished = res.data.list.length < 20;
        this.myparticipatelist.push(...res.data.list);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    toMeetingDetails(id, goodsId, open = "") {
      window.open(
        this.$global.meetingH5Url +
          `pagesModule/meetingDetails/index?type=8&id=${id || goodsId}${
            open ? "&open=" + open : ""
          }`,
        "_self"
      );
    },
    toEditDetails(item) {
      sessionStorage.setItem("currentMeetingInfo", JSON.stringify(item));
      this.$router.push({
        name: "mymeetingEdit",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.participate-box {
  .participate-item {
    margin: 0 auto 20px;
    width: 351px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    .participate-item-img {
      width: 100%;
      height: 197px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .icon-img {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 45px;
        height: 20px;
      }
    }
    .participate-item-content {
      padding: 12px;
      .title {
        font-weight: 700;
        font-size: 16px;
        color: #333333;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
      .intro-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
        font-size: 13px;
        color: #999999;
      }
      .btn-box {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 18px;
        .btn-item {
          margin-left: 15px;
          padding: 8px 15px;
          font-size: 14px;
          color: #4a79f1;
          border: 1px solid #4a79f1;
          border-radius: 20px;
        }
      }
    }
  }
}
</style>
